import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class VoucherCategoryGuardService implements CanActivate {

  voucherCate:any[];

  constructor(
    private router:Router
  ) { 
    this.voucherCate = ['voucher', 'ticket', 'gift'];
  }

  canActivate(route:ActivatedRouteSnapshot, state:RouterStateSnapshot){

    if(route.params.cate && this.voucherCate.indexOf(route.params.cate)>=0){
      return true;
    } else {
      this.router.navigate(['/404']);
      return false;
    }
  }

}
